// extracted by css-extract-rspack-plugin
export default {"Dialog":"ControlsDialog-module__Dialog__e6DMmnN"};